<template>
  <div class="relative flex items-start">
    <div
      class="flex h-6 items-center"
      :class="
        computedDisabled
          ? loading
            ? 'cursor-progress'
            : 'cursor-not-allowed opacity-60'
          : ''
      "
    >
      <input
        v-model="checked"
        :id="id"
       
        :aria-describedby="id + '-description'"
        :name="id"
        type="checkbox"
        class="size-5 cursor-pointer rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 lg:size-4"
        :class="{
          'pointer-events-none': computedDisabled,
        }"
        :disabled="computedDisabled"
        @keyup.enter="($event.target as HTMLElement)?.click()"
      />
    </div>
    <div v-if="label || description" class="text-sm leading-6">
      <label
        v-if="label"
        :for="id"
        class="block select-none pl-3 text-gray-900"
        :class="[
          description ? 'font-medium' : '',
          computedDisabled
            ? loading
              ? 'cursor-progress'
              : 'cursor-not-allowed'
            : 'cursor-pointer',
        ]"
      >
        {{ label }}
      </label>
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="description"
        :id="id + '-description'"
        class="pl-3 text-gray-500"
        v-html="replaceLinebreaks(description)"
      />
      <!-- eslint-enable -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import { replaceLinebreaks } from '@/util/formatter/text';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  description: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  dataTestid: {
    type: String,
    default: null,
  },
  isValueInverted: {
    // if modelValue === true, the checkbox is unchecked
    type: Boolean,
  },
});

const emit = defineEmits(['update:modelValue']);

const checked = computed({
  get: () => (props.isValueInverted ? !props.modelValue : props.modelValue),
  set: (value) => {
    if (!computedDisabled.value) {
      emit('update:modelValue', props.isValueInverted ? !value : value);
    }
  },
});

const computedDisabled = computed(() => props.disabled || props.loading);
</script>
